import { render, staticRenderFns } from "./KeyFeatures.vue?vue&type=template&id=6ef9c703"
import script from "./KeyFeatures.vue?vue&type=script&lang=js"
export * from "./KeyFeatures.vue?vue&type=script&lang=js"
import style0 from "./KeyFeatures.vue?vue&type=style&index=0&id=6ef9c703&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports